module.exports = __webpack_public_path__ + "static/media/hardware2.a3957a39.png";